<ion-list lines="none" mode="md">
  <ion-item
    *ngFor="let obj of preguntas; let i = index"
    [attr.data-index]="i"
    lines="none"
    mode="md"
  >
    <pregunta
      [setPregunta]="i + 1 + '.- ' + obj.Descripcion"
      [setPregunta2]="obj.MejoraTitulo"
      [idCalificaPregunta]="obj.ID_CalificaPregunta"
      [idCalificaRegion]="obj.ID_CalificanosRegion"
      [idTendero]="obj.ID_Tendero"
      (valueEmit)="cambioPregunta($event)"
    ></pregunta>
  </ion-item>
</ion-list>

<div class="ion-padding">
  <ion-button
    expand="block ion-text-uppercase"
    type="submit"
    (click)="mandarDatos()"
    [disabled]="!isEnabled"
    id="enviar"
  >
    <ion-spinner name="crescent" slot="start" *ngIf="spinner"></ion-spinner>
    Enviar
  </ion-button>
</div>
